import { type Scalars } from 'cms/cms-types';
import { format } from 'date-fns';

export const resolveDate = (value: Scalars['Date']): string | undefined => {
    if (!value) {
        return undefined;
    }

    return format(new Date(value), 'd MMM yyyy');
};
